import { useCallback, useEffect, useState } from "react";
import { useAllAccountSummary, useCreditAccounts, } from "../const/syfApiQueries";
import getEnrollmentAccounts from "../helpers/getEnrollmentAccounts";
var useVantageEligibility = function () {
    var _a;
    var _b = useState(true), shouldShowLoader = _b[0], setShouldShowLoader = _b[1];
    var _c = useState([]), currentEnrolledAccounts = _c[0], setCurrentEnrolledAccounts = _c[1];
    var _d = useState(""), accountToBeEnrolled = _d[0], setAccountToBeEnrolled = _d[1];
    // Getting Credit Accounts
    var _e = useCreditAccounts(), creditAccounts = _e.data, isCreditAccountsLoading = _e.isLoading, creditAccountsError = _e.error;
    // Getting all the Account Summaries
    var accountSummaries = useAllAccountSummary((_a = creditAccounts === null || creditAccounts === void 0 ? void 0 : creditAccounts.accounts) !== null && _a !== void 0 ? _a : []);
    var isLoadingAccountSummaries = accountSummaries.some(function (accountSummary) { return accountSummary.isLoading; });
    var accountSummaryError = accountSummaries.some(function (accountSummary) { return accountSummary.error; });
    var isLoading = isCreditAccountsLoading || isLoadingAccountSummaries;
    var error = creditAccountsError ||
        (creditAccounts && (creditAccounts === null || creditAccounts === void 0 ? void 0 : creditAccounts.accounts.length) <= 0) ||
        accountSummaryError;
    var getVantageAccounts = useCallback(function () {
        var _a = getEnrollmentAccounts(accountSummaries), accountToEnroll = _a.accountToEnroll, enrolledAccounts = _a.enrolledAccounts;
        setAccountToBeEnrolled(accountToEnroll);
        setCurrentEnrolledAccounts(enrolledAccounts);
        setShouldShowLoader(false);
    }, [accountSummaries]);
    useEffect(function () {
        if (error) {
            setShouldShowLoader(false);
        }
        if (!error && !isLoading) {
            getVantageAccounts();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error, isLoading]);
    var leadingEnrolledAccount = currentEnrolledAccounts.length > 0 ? currentEnrolledAccounts[0] : "";
    return {
        isLoading: isLoading || shouldShowLoader,
        error: error,
        currentEnrolledAccounts: currentEnrolledAccounts,
        leadingEnrolledAccount: leadingEnrolledAccount,
        accountToBeEnrolled: accountToBeEnrolled,
    };
};
export default useVantageEligibility;
